import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { AccessItem } from './AccessItem';
import { access } from '../../../model/access';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    // onReminderClick: (id: string) => void;
    accessList: Array<access>;
    selected: string;
    showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}

export const AccessList = (props: IProps) => {
    const classes = props.classes;
    return (
    <List className={classes?.root}>
        {props.accessList !== undefined && props.accessList.map(r =>
            <AccessItem
                classes={classes}
                isSelected={props.selected === r._id}
                access={r}
                key={r._id}
                // doneReminder={props.doneReminder}
                // onReminderClick={props.onReminderClick}
                showContactInfo={props.showContactInfo}
                // navigateTo={props.navigateTo}
            />)}
    </List>)
};